import React from 'react';

// Uma casa da grade. React.memo com PROPS PRIMITIVAS APENAS (ver crossword/Cell.tsx):
// `onClick` é uma referência estável do Canvas e a célula o chama com o próprio x,y.

export interface CellProps {
  x: number;
  y: number;
  black: boolean;
  letter: string;
  highlighted: boolean;
  onClick: (x: number, y: number) => void;
}

export const CELL_SIZE = 32;

const CellComponent: React.FC<CellProps> = ({ x, y, black, letter, highlighted, onClick }) => (
  <div
    role="gridcell"
    data-testid={`cell-${x}-${y}`}
    onClick={() => onClick(x, y)}
    style={{
      boxSizing: 'border-box',
      width: CELL_SIZE,
      height: CELL_SIZE,
      border: '1px solid #d9d9d9',
      background: black ? '#141414' : highlighted ? '#e6f4ff' : '#ffffff',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      cursor: black || !letter ? 'default' : 'pointer',
      userSelect: 'none',
      fontSize: 16,
      fontWeight: 600,
    }}
  >
    {black ? null : letter}
  </div>
);

export const Cell = React.memo(CellComponent);
